export default "__VITE_ASSET__3f1b9642__"